import { z } from 'zod';

import { zodSuccessResponseSchema } from '../validations';

export const zodBillDlnItemPayloadSchema = z.object({
  billedQuantityFactor: z.number().min(0).max(1),
});

export const zodBillDlnItemEndpointSchema = z.tuple([
  z.literal('delivery_note'),
  z.uuid(),
  z.literal('item'),
  z.number().int(),
  z.literal('bill'),
]);

export const zodBillDlnItemResponseSchema = zodSuccessResponseSchema;
